export default {
  HANDLEMODALHOME: 'HANDLE_MODAL_HOME',
  HANDLELOADINGHOME: 'HANDLE_LOADING_HOME',
  HANDLECHANGEHOME: 'HANDLE_CHANGE_HOME',
  HANDLEERRORHOME: 'HANDLE_ERROR_HOME',
};
